<template>
  <div
    class="d-flex padding-t-4"
    :class="{
      'justify-space-between margin-b-4 align-center': !isSingleColumn,
      'flex-column margin-b-4 ': isSingleColumn,
    }"
  >
    <h1
      class="font-28"
      :class="{
        'margin-b-2': isSingleColumn,
        'text-center': fullWidth,
        'margin-b-0': !fullWidth,
      }"
    >
      {{ title }}
    </h1>
    <div
      v-if="!isInGuestCheckout"
      class="d-flex align-center"
      :class="{ 'justify-end': !fullWidth, 'justify-center': fullWidth }"
    >
      <ShareQuoteDialog
        v-if="showShareQuoteDialog"
        :quote-id="quoteId"
      />

      <DownloadQuoteButton
        v-if="quote.hash && companyId"
        :quote-id="quote.quoteId"
        :quote-hash="quote.hash"
        :company-id="companyId"
        class="margin-l-2"
      />

      <v-btn
        id="quote-detail-button-contact-support"
        text
        color="primary"
        class="padding-x-2"
        small
        @click.stop="openSupport"
      >
        {{ $t('common.CONTACT_SUPPORT') }}
      </v-btn>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Component, Prop, Inject } from 'vue-property-decorator'
import ShareQuoteDialog from '@/components/ShareQuoteDialog.vue'
import DownloadQuoteButton from '@/components/DownloadQuoteButton.vue'
import { Quote } from '../models/dto'
import { PricingMethod, SplitFeatureFlag } from '@/utils/enum'
import auth from '../store/modules/auth'
import support from '../store/modules/support'
import CustomerAccountDefaultValueSet from '@/models/dto/CustomerAccountDefaultValueSet'

@Component({ components: { ShareQuoteDialog, DownloadQuoteButton } })
export default class CheckoutHeader extends Vue {
  @Inject({ from: 'isInGuestCheckout', default: false }) readonly isInGuestCheckout: boolean

  @Prop({ type: Object, required: true }) quote!: Quote
  @Prop({ type: Boolean, default: false }) isSingleColumn!: boolean
  @Prop({ type: Boolean, default: false }) fullWidth!: boolean
  @Prop({ type: Object, default: () => {} }) effectiveDefaultValueSet!: CustomerAccountDefaultValueSet
  @Prop({ type: String, required: true }) title!: string

  isUserRoleManagementEnabled = false

  get quoteId(): number {
    return this.quote?.quoteId
  }

  get companyId(): number | undefined {
    return parseInt(this.$route.params.providerId)
  }

  get isBidListQuote(): boolean {
    return this.quote?.pricingMethod === PricingMethod.Bids
  }

  get showShareQuoteDialog(): boolean {
    if (!this.quote) {
      return false
    }
    if (this.isUserRoleManagementEnabled) {
      return true
    } else {
      return this.isUserQuoteCustomer || this.isUserInSameOrganization
    }
  }

  get isUserQuoteCustomer(): boolean {
    const quoteCustomerId = this.quote?.trips?.[0]?.customerId
    return quoteCustomerId === auth.user?.userId
  }

  get isUserInSameOrganization(): boolean {
    const quoteCustomerCustomerAccountId = this.quote?.trips?.[0]?.customer?.customerAccountId
    if (!quoteCustomerCustomerAccountId) {
      return false
    }
    return (
      quoteCustomerCustomerAccountId ===
        auth.customerAccount.customerAccountId ||
        auth.childCustomerAccountIds.includes(quoteCustomerCustomerAccountId)
    )
  }

  async mounted() {
    this.isUserRoleManagementEnabled = await this.$split.isFeatureEnabled(
      SplitFeatureFlag.UserRoleManagement
    )
  }

  openSupport(): void {
    support.open({
      reservationId: null,
      quoteId: this.quoteId,
    })
  }
}
</script>
